export const PAGE_TITLES = [
  '背景画像を選択',
  'QRの配置を決定',
  '店名の配置を決定',
];

export const SIZE_TABLE = {
  'S': [614, 874],
  'M': [874, 1240],
  'L': [1240, 1748],
}

export const CANVAS_WIDTH = Math.round(SIZE_TABLE.S[0] / 2);
export const CANVAS_HEIGHT = Math.round(SIZE_TABLE.S[1] / 2);

export const QRCODE_MIN_SIZE = 32;
